// DDMMYYYY-subversion

export const VERSION = '1.0.00002032023-1'

